/* 🤖 this file was generated by svg-to-ts */
export const iconZerionwallet: {
  name: 'zerionwallet';
  data: string;
} = {
  name: 'zerionwallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="#3861E5" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"/><path fill="#fff" d="M6.94 8c-.55 0-.76.68-.3.96l11.51 6.94c.29.18.67.11.87-.16l5.06-6.64c.34-.46 0-1.1-.6-1.1zm18.1 16c.55 0 .77-.68.31-.96L13.83 16.1a.644.644 0 0 0-.86.17L7.9 22.91c-.34.46.01 1.09.61 1.09z"/></svg>`,
};
